function AddProductToCart(productsArr, $this, open=false){
  if($this != null){
    $this.addClass("active");
  }
  let formData = {
    'items': productsArr,
    sections: "cart-drawer,cart-icon-bubble"
  };
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'xmlhttprequest'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .then(res => {
    if(res.status){
      console.log(res);
    }
    else{
      const cartParsedData = new DOMParser().parseFromString(res.sections['cart-drawer'], 'text/html');
      const cartBubbleParsedData = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
      $("cart-drawer.drawer").removeClass("is-empty");
      $(".drawer__inner").html($(cartParsedData).find(".drawer__inner").html());
      $("#cart-icon-bubble").html($(cartBubbleParsedData).find(".shopify-section").html());
      if(open){
        document.querySelector("#cart-icon-bubble").dispatchEvent(new Event('click'));
        $(".cart-count-bubble").trigger("click");
      }
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'custom-add'
      });
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  })
  .finally(() => {
    if($this != null){
      $this.removeClass("active");
    }
  });
}
function UpdateProductToCart(item){
  let formData = {
    updates: item,
    sections: "cart-drawer,cart-icon-bubble"
  };
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'xmlhttprequest'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .then(res => {
    if(res.status){
      console.log(res);
    }
    else{
      const cartParsedData = new DOMParser().parseFromString(res.sections['cart-drawer'], 'text/html');
      const cartBubbleParsedData = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
      $("cart-drawer.drawer").removeClass("is-empty");
      $(".drawer__inner").html($(cartParsedData).find(".drawer__inner").html());
      $("#cart-icon-bubble").html($(cartBubbleParsedData).find(".shopify-section").html());
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  })
}
$(document).on("click", ".new-fp-atc", function(e){
  e.preventDefault();
  e.stopPropagation();
  let arr = [];
  arr.push({ 'id': $(this).attr("data-id"), 'quantity': 1 });
  AddProductToCart(arr, $(this), true);
})
$(document).on("click", ".new-faq-title", function(){
  $(this).toggleClass("active");
  $(this).next(".new-faq-text").slideToggle(150);
})
$(document).on("click", ".new-cart-cross-btn", function(e){
  e.preventDefault();
  e.stopPropagation();
  let arr = [];
  arr.push({ 'id': $(this).attr("data-id"), 'quantity': 1 });
  AddProductToCart(arr, $(this));
})
$(document).on("change", ".new-main-product-variants-inp", function(){
    $(".new-main-product-variants-title span").text($(this).attr("data-title"));
    let img = $(this).attr("data-img");
    if($(`.new-main-product-swiper-slide[data-img="${img}"]`).length > 0){
      let index = $(`.new-main-product-swiper-slide[data-img="${img}"]`).attr("data-index");
      $(".new-main-product-swiper")[0].swiper.slideTo(index);
    }
    $(".new-main-product-price").html($(this).attr("data-price"));
    let badge = $(this).attr("data-badge");
    $(".new-main-product-media-badge").removeClass("active");
    if(badge != "none"){
      $(".new-main-product-media-badge p em").text(badge);
      $(".new-main-product-media-badge").addClass("active");
    }
    $(".new-main-product-vid").val($(this).val());
    $(".new-main-product-vid").attr("value", $(this).val())
    $(".new-main-product-atc-btn, .new-main-product-atc-btn-2").attr("data-id", $(this).val());
    let iq = $(this).attr("data-sold").trim();
    let soldText = $(".new-main-product-atc-btn").attr("data-sold");
    let atcText = $(".new-main-product-atc-btn").attr("data-atc");
    if(iq == "sold"){
      $(".new-main-product-atc-btn, .new-main-product-atc-btn-2").text(soldText);
      $(".new-main-product-atc-btn, .new-main-product-atc-btn-2").addClass("sold");
    }
    else{
      $(".new-main-product-atc-btn, .new-main-product-atc-btn-2").text(atcText);
      $(".new-main-product-atc-btn, .new-main-product-atc-btn-2").removeClass("sold");
    }
})
$(document).on("click", ".new-main-product-atc-btn, .new-main-product-atc-btn-2", function(e){
  e.preventDefault();
  e.stopPropagation();
  let arr = [];
  arr.push({ 'id': $(this).attr("data-id"), 'quantity': 1 });
  if($(".new-main-product-upsells-item-inp:checked").length > 0){
    $(".new-main-product-upsells-item-inp:checked").each(function(){
      arr.push({ 'id': $(this).val(), 'quantity': 1 });
    })
  }
  AddProductToCart(arr, $(this), true);
})
$(document).on("click", ".new-pi-btn", function(){
  $(this).parent().find(".new-pi-info-item").removeClass("active");
  if($(this).hasClass("active")){
    $(this).removeClass("active");
    $(this).parent().find(`.new-pi-info-item[data-index="1"]`).addClass("active");
    $(this).parent().find(`.new-pi-info-item[data-index="2"]`).addClass("active");
    $(this).parent().find(`.new-pi-info-item[data-index="3"]`).addClass("active");
    $(this).parent().find(`.new-pi-info-item[data-index="4"]`).addClass("active");
    $(this).parent().find(`.new-pi-info-item[data-index="5"]`).addClass("active");
  }
  else{
    $(this).addClass("active");
    $(this).parent().find(".new-pi-info-item").addClass("active");
  }
})
$(document).scroll(function() {
  if($(".new-main-product-atc-btn").length > 0){
    var y = $(this).scrollTop();
    var btnOff = $(".new-main-product-atc-btn").offset().top + $(".new-main-product-atc-btn").height();
    console.log(y, btnOff);
    if (y > btnOff) {
      $('.new-main-product-sticky-wrapper').addClass("active");
    } else {
      $('.new-main-product-sticky-wrapper').removeClass("active");
    }
  }
});
class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.durationHours = parseFloat(this.getAttribute('duration-hours')) || 24;
    this.cookieName = 'countdown_start_time';
  }

  connectedCallback() {
    this.innerHTML = `<span id="timer">--:--:--</span>`;
    this.timerElement = this.querySelector('#timer');
    this.start();
  }

  setCookie(name, value, days) {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
  }

  getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  start() {
    const durationMs = this.durationHours * 60 * 60 * 1000;
    const now = new Date();
    let startTime = this.getCookie(this.cookieName);

    if (!startTime) {
      startTime = now.getTime();
      this.setCookie(this.cookieName, startTime, 7);
    } else {
      startTime = parseInt(startTime, 10);
    }

    const update = () => {
      const current = Date.now();
      let elapsed = current - startTime;

      if (elapsed >= durationMs) {
        // Restart automatically
        startTime = Date.now();
        this.setCookie(this.cookieName, startTime, 7);
        elapsed = 0;
      }

      const remaining = durationMs - elapsed;
      const hours = Math.floor((remaining / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((remaining / (1000 * 60)) % 60);
      const seconds = Math.floor((remaining / 1000) % 60);

      this.timerElement.textContent = 
        `${hours.toString().padStart(2, '0')}h : ${minutes
          .toString()
          .padStart(2, '0')}m : ${seconds.toString().padStart(2, '0')}s`;

      requestAnimationFrame(update);
    };

    update();
  }
}

if (!customElements.get('countdown-timer')) {
  customElements.define('countdown-timer', CountdownTimer);
}


document.addEventListener('DOMContentLoaded', () => {
  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    console.log(event.source);
    if(event.source == 'custom-add'){
      if($("body").attr("data-pid") != undefined && $("body").attr("data-pid") != ''){
        UpdateProductToCart({
          [$("body").attr("data-pid")]: 1
        });
      }
    }
    else if(event.source == 'cart-items'){
      if($("body").attr("data-pid") != undefined && $("body").attr("data-pid") != ''){
        if($("body").attr("data-pid") == event.cartData.items[0].id && event.cartData.item_count == 1){
          UpdateProductToCart({
            [$("body").attr("data-pid")]: 0
          });
        }
      }
    }
  });
});

$(document).on("change", ".new-cp-inp", function(){
  if($(this).is(":checked")){
    UpdateProductToCart({
      [$(this).val()]: 1
    });
  }
  else{
    UpdateProductToCart({
      [$(this).val()]: 0
    });
  }
})